import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontFamily: 'Inter',
    color: 'white',
    marginBottom:'25px',
    paddingTop: '0px'
  }
}));

export default useStyles;
